import type { SVGProps } from 'react'

/** General accessibility includes sensory, cognitive and situational needs.
 * Use the person symbol consistently, rather than a mobility-specific icon.
 * The surrounding control supplies the accessible name.
 */
export function AccessibilityIcon({ width = 22, height = 22, ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={width}
      height={height}
      fill="currentColor"
      {...props}
      aria-hidden="true"
      focusable="false"
    >
      <circle cx="12" cy="4" r="2" />
      <path d="M4 9h5v6l-1 6h2l1-5h2l1 5h2l-1-6V9h5V7H4z" />
    </svg>
  )
}
